const convertJsonToPropsInLocale = (fields, locale, transformer) => {
  if (!locale) {
    // eslint-disable-next-line no-console
    console.error('Locale must be specified');
  }

  const getValueByLocale = (val) => {
    // if the value has a property that matches the locale we passed in, use that as the new value
    // otherwise use the original value
    const hasLocalizedVal = typeof val[locale] !== 'undefined';
    const value = hasLocalizedVal ? val[locale] : val;
    // if the value is an array, recursively get the value for each element in the array
    if (Array.isArray(value)) {
      return [...value].map((v) => getValueByLocale(v));
    }
    // if the value has child fields, recursively convert the json for those fields
    if (value.fields) {
      const { sys: { contentful_id: id, type, contentType } } = value;
      const relatedObject = {
        id,
        type,
        contentType: contentType ? contentType.sys.contentful_id : null,
      };
      const transformation = transformer ? transformer(relatedObject, value.fields) : {};
      return {
        ...convertJsonToPropsInLocale(value.fields, locale, transformer),
        ...transformation,
      };
    }
    // otherwise just return the value
    return value;
  };

  // process each field and reset the value for the key to the locale that was passed in
  return Object.entries(fields).reduce((prev, [key, value]) => {
    const currentObject = { ...prev, [key]: getValueByLocale(value, locale) };
    return currentObject;
  }, {});
};

module.exports = convertJsonToPropsInLocale;
